'use client';

import Image from 'next/image';
import React from 'react';
import { Modal } from '@ui';

export type ImageCardModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  rawSrc: string;
  overlayDescription?: string;
};

function imageCardModalId(title: string) {
  return `image-card-modal-${title.toLowerCase().replace(/\s+/g, '-')}`;
}

const ImageCardModal: React.FC<ImageCardModalProps> = ({
  open,
  onClose,
  title,
  rawSrc,
  overlayDescription,
}) => (
  <Modal
    open={open}
    onClose={onClose}
    title={title}
    id={imageCardModalId(title)}
    size='lg'
    className='image-card-modal'
  >
    <div className='image-card-modal-content'>
      <div className='image-card-modal-media'>
        <Image
          src={rawSrc}
          alt={title}
          width={1200}
          height={900}
          style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
          unoptimized={rawSrc.toLowerCase().endsWith('.svg')}
        />
      </div>
      {overlayDescription ? (
        <p className='image-card-modal-description'>{overlayDescription}</p>
      ) : null}
    </div>
  </Modal>
);

export default ImageCardModal;
